import React from "react";
import titleize from "Utils/titleize";
import { clickableAddress, formatUrl } from "./helpers";

const ShopFocus = (props) => {
  const {
    address: { street, city, state },
    attachment_url,
    shop_name,
    phone,
    steer_id,
    services,
    specialties,
    url,
    displayUrl,
    children,
  } = props;

  return (
    <div className="fb-modal" onClick={() => props.setModal(false)}>
      <div className="bg-white border min-w-25">
        <div className="p-6 leading-loose text-lg bg-white flex space-x-8">
          {attachment_url && (
            <div className="w-2/5">
              <img
                className="w-64"
                src={attachment_url}
                alt={`${shop_name} image`}
              />
            </div>
          )}
          <div>
            <h2 className="mb-2 font-sans font-bold text-brand-blue text-xl lg:text-lg">
              {shop_name ? shop_name : null}
            </h2>
            {clickableAddress(street, city, state)}
            <svg
              className="w-4 inline-block mr-2 text-brand-blue"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <title>Phone Icon</title>
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
            </svg>
            <a
              className="text-brand-textgray font-sans inline-block text-md"
              href={`tel:${phone}`}
            >
              {phone}
            </a>
            <br />
            {url && (
              <>
                <svg
                  className="w-4 inline-block mr-2 text-brand-blue"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Phone Icon</title>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                  ></path>
                </svg>
                <a
                  className="text-brand-blue underline"
                  href={url}
                  target="_blank"
                >
                  {displayUrl}
                </a>
              </>
            )}
            <br />
            {steer_id && (
              <div className="flex mt-2">
                <>
                  <button
                    className="bg-brand-red hover:bg-brand-redhighlight text-sm text-white px-4 rounded self-end h-12"
                    type="button"
                    onClick={() =>
                      AutoOps.show({portalKey: steer_id, ao_affiliate:'TechNet', brandKey:'main_technet_locator'})
                    }
                  >
                    Book Appointment
                  </button>
                </>
              </div>
            )}
          </div>
        </div>
        {Object.values(specialties)
          .concat(Object.values(services))
          .some((s) => s === true) && (
          <div className="bg-brand-mediumgray rounded-r pt-6 px-6">
            <div className="flex space-x-10">
              {Object.values(services).some((s) => s === true) && (
                <div>
                  <h2 className="text-brand-blue font-bold leading-tight">
                    Services
                  </h2>
                  <ul className="font-light text-brand-textgray text-sm">
                    {Object.entries(services).map(
                      ([service, available]) =>
                        available && (
                          <li key={service}>
                            {service ? titleize(service) : null}
                          </li>
                        )
                    )}
                  </ul>
                </div>
              )}
              {Object.values(specialties).some((s) => s === true) && (
                <div>
                  <h2 className="text-brand-blue font-bold leading-tight">
                    Specialties
                  </h2>
                  <ul className="font-light text-brand-textgray text-sm">
                    {Object.entries(specialties).map(
                      ([service, available]) =>
                        available && (
                          <li key={service}>
                            {service ? titleize(service) : null}
                          </li>
                        )
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="bg-brand-mediumgray rounded-r p-6">{children}</div>
        <button className="close" onClick={() => props.setModal(false)}>
          &times;
        </button>
      </div>
    </div>
  );
};

export default ShopFocus;
